<p-dialog
  [(visible)]="visivel"
  [style]="{ width: '450px' }"
  header="Novo Usuário"
  [modal]="true"
  styleClass="p-fluid"
  (onHide)="escondeDialog()"
>
  <ng-template pTemplate="content">
    <div class="field">
      <label for="nome">Nome:</label>
      <input id="nome" pInputText type="text" [(ngModel)]="usuario.nomeUsuario" required autofocus />
      <small class="p-error" *ngIf="usuarioEnviado && !usuario.nomeUsuario">Nome é obrigatório.</small>
    </div>
    <div class="field">
        <label for="nome">E-mail:</label>
        <input id="nome" pInputText type="text" [(ngModel)]="usuario.email" required autofocus />
        <small class="p-error" *ngIf="usuarioEnviado && !usuario.email">E-mail é obrigatório.</small>
    </div>
    <div class="field">
      <label for="nome">Usuário ERP:</label>
      <input id="nome" pInputText type="text" [(ngModel)]="usuario.cdUsuarioErp" required autofocus />
      <small class="p-error" *ngIf="usuarioEnviado && !usuario.cdUsuarioErp">Usuário ERP é obrigatório.</small>
  </div>
    <div class="field">
      <label for="base">Perfil:</label>
      <!-- <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="perfis" optionValue="id" optionLabel="nomePerfil" [(ngModel)]="usuario.perfilId" dataKey="id" inputId="id" placeholder="Selecione um perfil" emptyMessage="Nenhum perfil disponivel"></p-dropdown> -->
      <p-multiSelect  [options]="perfis" appendTo="body"  [(ngModel)]="perfisSelecionados" placeholder="Selecione um Perfil" optionValue="id" optionLabel="nomePerfil" display="chip" styleClass="w-full md:w-80" />
      <small class="p-error" *ngIf="usuarioEnviado && perfisSelecionados.length === 0 ">Perfil é obrigatório.</small>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-text"
      (click)="escondeDialog()"
      [loading]="loading"
    ></button>
    <button
      pButton
      label="Salvar"
      icon="pi pi-check"
      class="p-button-text"
      (click)="salvar()"
      [loading]="loading"
    ></button>
  </ng-template>
</p-dialog>
